// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { ConversationCloseResponseDatagramBuf } from '../response/conversation-close-response-datagram-buf.js';
import { ConversationCreateResponseDatagramBuf } from '../response/conversation-create-response-datagram-buf.js';
import { ConversationDeleteResponseDatagramBuf } from '../response/conversation-delete-response-datagram-buf.js';
import { ConversationPropertiesResponseDatagramBuf } from '../response/conversation-properties-response-datagram-buf.js';
import { ConversationSubscribeResponseDatagramBuf } from '../response/conversation-subscribe-response-datagram-buf.js';
import { ConversationTurnResponseDatagramBuf } from '../response/conversation-turn-response-datagram-buf.js';
import { ConversationUpdateResponseDatagramBuf } from '../response/conversation-update-response-datagram-buf.js';
import { FileCopyResponseDatagramBuf } from '../response/file-copy-response-datagram-buf.js';
import { FileCreateResponseDatagramBuf } from '../response/file-create-response-datagram-buf.js';
import { FileDeleteResponseDatagramBuf } from '../response/file-delete-response-datagram-buf.js';
import { FileDownloadResponseDatagramBuf } from '../response/file-download-response-datagram-buf.js';
import { FileEditResponseDatagramBuf } from '../response/file-edit-response-datagram-buf.js';
import { FileFindResponseDatagramBuf } from '../response/file-find-response-datagram-buf.js';
import { FileHistoryResponseDatagramBuf } from '../response/file-history-response-datagram-buf.js';
import { FileMoveResponseDatagramBuf } from '../response/file-move-response-datagram-buf.js';
import { FilePrepareResponseDatagramBuf } from '../response/file-prepare-response-datagram-buf.js';
import { FilePropertiesResponseDatagramBuf } from '../response/file-properties-response-datagram-buf.js';
import { FileRevisionResponseDatagramBuf } from '../response/file-revision-response-datagram-buf.js';
import { FileRootHistoryResponseDatagramBuf } from '../response/file-root-history-response-datagram-buf.js';
import { FileShareResponseDatagramBuf } from '../response/file-share-response-datagram-buf.js';
import { FileUpdateResponseDatagramBuf } from '../response/file-update-response-datagram-buf.js';
import { FilesSharedWithSelfResponseDatagramBuf } from '../response/files-shared-with-self-response-datagram-buf.js';
import { FolderContentHistoryResponseDatagramBuf } from '../response/folder-content-history-response-datagram-buf.js';
import { FolderListPageResponseDatagramBuf } from '../response/folder-list-page-response-datagram-buf.js';
import { FolderSubscribeResponseDatagramBuf } from '../response/folder-subscribe-response-datagram-buf.js';
import { SearchAutocompleteResponseDatagramBuf } from '../response/search-autocomplete-response-datagram-buf.js';
import { SearchListPageResponseDatagramBuf } from '../response/search-list-page-response-datagram-buf.js';
import { SearchUpdateResponseDatagramBuf } from '../response/search-update-response-datagram-buf.js';
import { SelfConversationsResponseDatagramBuf } from '../response/self-conversations-response-datagram-buf.js';
import { SelfInfoResponseDatagramBuf } from '../response/self-info-response-datagram-buf.js';
import { SelfSharedFoldersResponseDatagramBuf } from '../response/self-shared-folders-response-datagram-buf.js';
import { SelfSidebarResponseDatagramBuf } from '../response/self-sidebar-response-datagram-buf.js';
import { SelfUpdateResponseDatagramBuf } from '../response/self-update-response-datagram-buf.js';
import { SharedFolderCreateResponseDatagramBuf } from '../response/shared-folder-create-response-datagram-buf.js';
import { SharedFolderDeleteResponseDatagramBuf } from '../response/shared-folder-delete-response-datagram-buf.js';
import { SharedFolderFindResponseDatagramBuf } from '../response/shared-folder-find-response-datagram-buf.js';
import { SharedFolderMembershipResponseDatagramBuf } from '../response/shared-folder-membership-response-datagram-buf.js';
import { UserFindResponseDatagramBuf } from '../response/user-find-response-datagram-buf.js';
import { UserThumbnailResponseDatagramBuf } from '../response/user-thumbnail-response-datagram-buf.js';


export class ResponseDatagramBuf {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):ResponseDatagramBuf {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsResponseDatagramBuf(bb:flatbuffers.ByteBuffer, obj?:ResponseDatagramBuf):ResponseDatagramBuf {
  return (obj || new ResponseDatagramBuf()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsResponseDatagramBuf(bb:flatbuffers.ByteBuffer, obj?:ResponseDatagramBuf):ResponseDatagramBuf {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new ResponseDatagramBuf()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

conversationCreateResponse(obj?:ConversationCreateResponseDatagramBuf):ConversationCreateResponseDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? (obj || new ConversationCreateResponseDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

conversationCloseResponse(obj?:ConversationCloseResponseDatagramBuf):ConversationCloseResponseDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? (obj || new ConversationCloseResponseDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

conversationSubscribeResponse(obj?:ConversationSubscribeResponseDatagramBuf):ConversationSubscribeResponseDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? (obj || new ConversationSubscribeResponseDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

conversationTurnResponse(obj?:ConversationTurnResponseDatagramBuf):ConversationTurnResponseDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 10);
  return offset ? (obj || new ConversationTurnResponseDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

fileCopyResponse(obj?:FileCopyResponseDatagramBuf):FileCopyResponseDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 12);
  return offset ? (obj || new FileCopyResponseDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

fileCreateResponse(obj?:FileCreateResponseDatagramBuf):FileCreateResponseDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 14);
  return offset ? (obj || new FileCreateResponseDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

fileDeleteResponse(obj?:FileDeleteResponseDatagramBuf):FileDeleteResponseDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 16);
  return offset ? (obj || new FileDeleteResponseDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

fileDownloadResponse(obj?:FileDownloadResponseDatagramBuf):FileDownloadResponseDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 18);
  return offset ? (obj || new FileDownloadResponseDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

fileEditResponse(obj?:FileEditResponseDatagramBuf):FileEditResponseDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 20);
  return offset ? (obj || new FileEditResponseDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

fileHistoryResponse(obj?:FileHistoryResponseDatagramBuf):FileHistoryResponseDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 22);
  return offset ? (obj || new FileHistoryResponseDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

fileMoveResponse(obj?:FileMoveResponseDatagramBuf):FileMoveResponseDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 24);
  return offset ? (obj || new FileMoveResponseDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

filePrepareResponse(obj?:FilePrepareResponseDatagramBuf):FilePrepareResponseDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 26);
  return offset ? (obj || new FilePrepareResponseDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

filePropertiesResponse(obj?:FilePropertiesResponseDatagramBuf):FilePropertiesResponseDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 28);
  return offset ? (obj || new FilePropertiesResponseDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

fileShareResponse(obj?:FileShareResponseDatagramBuf):FileShareResponseDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 30);
  return offset ? (obj || new FileShareResponseDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

fileUpdateResponse(obj?:FileUpdateResponseDatagramBuf):FileUpdateResponseDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 32);
  return offset ? (obj || new FileUpdateResponseDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

searchAutocompleteResponse(obj?:SearchAutocompleteResponseDatagramBuf):SearchAutocompleteResponseDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 34);
  return offset ? (obj || new SearchAutocompleteResponseDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

filesSharedWithSelfResponse(obj?:FilesSharedWithSelfResponseDatagramBuf):FilesSharedWithSelfResponseDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 36);
  return offset ? (obj || new FilesSharedWithSelfResponseDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

folderContentHistoryResponse(obj?:FolderContentHistoryResponseDatagramBuf):FolderContentHistoryResponseDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 38);
  return offset ? (obj || new FolderContentHistoryResponseDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

folderListPageResponse(obj?:FolderListPageResponseDatagramBuf):FolderListPageResponseDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 40);
  return offset ? (obj || new FolderListPageResponseDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

folderSubscribeResponse(obj?:FolderSubscribeResponseDatagramBuf):FolderSubscribeResponseDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 42);
  return offset ? (obj || new FolderSubscribeResponseDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

selfConversationsResponse(obj?:SelfConversationsResponseDatagramBuf):SelfConversationsResponseDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 44);
  return offset ? (obj || new SelfConversationsResponseDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

selfInfoResponse(obj?:SelfInfoResponseDatagramBuf):SelfInfoResponseDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 46);
  return offset ? (obj || new SelfInfoResponseDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

selfSharedFoldersResponse(obj?:SelfSharedFoldersResponseDatagramBuf):SelfSharedFoldersResponseDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 48);
  return offset ? (obj || new SelfSharedFoldersResponseDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

selfSidebarResponse(obj?:SelfSidebarResponseDatagramBuf):SelfSidebarResponseDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 50);
  return offset ? (obj || new SelfSidebarResponseDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

selfUpdateResponse(obj?:SelfUpdateResponseDatagramBuf):SelfUpdateResponseDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 52);
  return offset ? (obj || new SelfUpdateResponseDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

sharedFolderCreateResponse(obj?:SharedFolderCreateResponseDatagramBuf):SharedFolderCreateResponseDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 54);
  return offset ? (obj || new SharedFolderCreateResponseDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

sharedFolderDeleteResponse(obj?:SharedFolderDeleteResponseDatagramBuf):SharedFolderDeleteResponseDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 56);
  return offset ? (obj || new SharedFolderDeleteResponseDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

sharedFolderFindResponse(obj?:SharedFolderFindResponseDatagramBuf):SharedFolderFindResponseDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 58);
  return offset ? (obj || new SharedFolderFindResponseDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

sharedFolderMembershipResponse(obj?:SharedFolderMembershipResponseDatagramBuf):SharedFolderMembershipResponseDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 60);
  return offset ? (obj || new SharedFolderMembershipResponseDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

userFindResponse(obj?:UserFindResponseDatagramBuf):UserFindResponseDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 62);
  return offset ? (obj || new UserFindResponseDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

userThumbnailResponse(obj?:UserThumbnailResponseDatagramBuf):UserThumbnailResponseDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 64);
  return offset ? (obj || new UserThumbnailResponseDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

searchListPageResponse(obj?:SearchListPageResponseDatagramBuf):SearchListPageResponseDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 66);
  return offset ? (obj || new SearchListPageResponseDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

fileRootHistoryResponse(obj?:FileRootHistoryResponseDatagramBuf):FileRootHistoryResponseDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 68);
  return offset ? (obj || new FileRootHistoryResponseDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

conversationPropertiesResponse(obj?:ConversationPropertiesResponseDatagramBuf):ConversationPropertiesResponseDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 70);
  return offset ? (obj || new ConversationPropertiesResponseDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

searchUpdateResponse(obj?:SearchUpdateResponseDatagramBuf):SearchUpdateResponseDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 72);
  return offset ? (obj || new SearchUpdateResponseDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

fileFindResponse(obj?:FileFindResponseDatagramBuf):FileFindResponseDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 74);
  return offset ? (obj || new FileFindResponseDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

fileRevisionResponse(obj?:FileRevisionResponseDatagramBuf):FileRevisionResponseDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 76);
  return offset ? (obj || new FileRevisionResponseDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

conversationUpdateResponse(obj?:ConversationUpdateResponseDatagramBuf):ConversationUpdateResponseDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 78);
  return offset ? (obj || new ConversationUpdateResponseDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

conversationDeleteResponse(obj?:ConversationDeleteResponseDatagramBuf):ConversationDeleteResponseDatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 80);
  return offset ? (obj || new ConversationDeleteResponseDatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

static startResponseDatagramBuf(builder:flatbuffers.Builder) {
  builder.startObject(39);
}

static addConversationCreateResponse(builder:flatbuffers.Builder, conversationCreateResponseOffset:flatbuffers.Offset) {
  builder.addFieldOffset(0, conversationCreateResponseOffset, 0);
}

static addConversationCloseResponse(builder:flatbuffers.Builder, conversationCloseResponseOffset:flatbuffers.Offset) {
  builder.addFieldOffset(1, conversationCloseResponseOffset, 0);
}

static addConversationSubscribeResponse(builder:flatbuffers.Builder, conversationSubscribeResponseOffset:flatbuffers.Offset) {
  builder.addFieldOffset(2, conversationSubscribeResponseOffset, 0);
}

static addConversationTurnResponse(builder:flatbuffers.Builder, conversationTurnResponseOffset:flatbuffers.Offset) {
  builder.addFieldOffset(3, conversationTurnResponseOffset, 0);
}

static addFileCopyResponse(builder:flatbuffers.Builder, fileCopyResponseOffset:flatbuffers.Offset) {
  builder.addFieldOffset(4, fileCopyResponseOffset, 0);
}

static addFileCreateResponse(builder:flatbuffers.Builder, fileCreateResponseOffset:flatbuffers.Offset) {
  builder.addFieldOffset(5, fileCreateResponseOffset, 0);
}

static addFileDeleteResponse(builder:flatbuffers.Builder, fileDeleteResponseOffset:flatbuffers.Offset) {
  builder.addFieldOffset(6, fileDeleteResponseOffset, 0);
}

static addFileDownloadResponse(builder:flatbuffers.Builder, fileDownloadResponseOffset:flatbuffers.Offset) {
  builder.addFieldOffset(7, fileDownloadResponseOffset, 0);
}

static addFileEditResponse(builder:flatbuffers.Builder, fileEditResponseOffset:flatbuffers.Offset) {
  builder.addFieldOffset(8, fileEditResponseOffset, 0);
}

static addFileHistoryResponse(builder:flatbuffers.Builder, fileHistoryResponseOffset:flatbuffers.Offset) {
  builder.addFieldOffset(9, fileHistoryResponseOffset, 0);
}

static addFileMoveResponse(builder:flatbuffers.Builder, fileMoveResponseOffset:flatbuffers.Offset) {
  builder.addFieldOffset(10, fileMoveResponseOffset, 0);
}

static addFilePrepareResponse(builder:flatbuffers.Builder, filePrepareResponseOffset:flatbuffers.Offset) {
  builder.addFieldOffset(11, filePrepareResponseOffset, 0);
}

static addFilePropertiesResponse(builder:flatbuffers.Builder, filePropertiesResponseOffset:flatbuffers.Offset) {
  builder.addFieldOffset(12, filePropertiesResponseOffset, 0);
}

static addFileShareResponse(builder:flatbuffers.Builder, fileShareResponseOffset:flatbuffers.Offset) {
  builder.addFieldOffset(13, fileShareResponseOffset, 0);
}

static addFileUpdateResponse(builder:flatbuffers.Builder, fileUpdateResponseOffset:flatbuffers.Offset) {
  builder.addFieldOffset(14, fileUpdateResponseOffset, 0);
}

static addSearchAutocompleteResponse(builder:flatbuffers.Builder, searchAutocompleteResponseOffset:flatbuffers.Offset) {
  builder.addFieldOffset(15, searchAutocompleteResponseOffset, 0);
}

static addFilesSharedWithSelfResponse(builder:flatbuffers.Builder, filesSharedWithSelfResponseOffset:flatbuffers.Offset) {
  builder.addFieldOffset(16, filesSharedWithSelfResponseOffset, 0);
}

static addFolderContentHistoryResponse(builder:flatbuffers.Builder, folderContentHistoryResponseOffset:flatbuffers.Offset) {
  builder.addFieldOffset(17, folderContentHistoryResponseOffset, 0);
}

static addFolderListPageResponse(builder:flatbuffers.Builder, folderListPageResponseOffset:flatbuffers.Offset) {
  builder.addFieldOffset(18, folderListPageResponseOffset, 0);
}

static addFolderSubscribeResponse(builder:flatbuffers.Builder, folderSubscribeResponseOffset:flatbuffers.Offset) {
  builder.addFieldOffset(19, folderSubscribeResponseOffset, 0);
}

static addSelfConversationsResponse(builder:flatbuffers.Builder, selfConversationsResponseOffset:flatbuffers.Offset) {
  builder.addFieldOffset(20, selfConversationsResponseOffset, 0);
}

static addSelfInfoResponse(builder:flatbuffers.Builder, selfInfoResponseOffset:flatbuffers.Offset) {
  builder.addFieldOffset(21, selfInfoResponseOffset, 0);
}

static addSelfSharedFoldersResponse(builder:flatbuffers.Builder, selfSharedFoldersResponseOffset:flatbuffers.Offset) {
  builder.addFieldOffset(22, selfSharedFoldersResponseOffset, 0);
}

static addSelfSidebarResponse(builder:flatbuffers.Builder, selfSidebarResponseOffset:flatbuffers.Offset) {
  builder.addFieldOffset(23, selfSidebarResponseOffset, 0);
}

static addSelfUpdateResponse(builder:flatbuffers.Builder, selfUpdateResponseOffset:flatbuffers.Offset) {
  builder.addFieldOffset(24, selfUpdateResponseOffset, 0);
}

static addSharedFolderCreateResponse(builder:flatbuffers.Builder, sharedFolderCreateResponseOffset:flatbuffers.Offset) {
  builder.addFieldOffset(25, sharedFolderCreateResponseOffset, 0);
}

static addSharedFolderDeleteResponse(builder:flatbuffers.Builder, sharedFolderDeleteResponseOffset:flatbuffers.Offset) {
  builder.addFieldOffset(26, sharedFolderDeleteResponseOffset, 0);
}

static addSharedFolderFindResponse(builder:flatbuffers.Builder, sharedFolderFindResponseOffset:flatbuffers.Offset) {
  builder.addFieldOffset(27, sharedFolderFindResponseOffset, 0);
}

static addSharedFolderMembershipResponse(builder:flatbuffers.Builder, sharedFolderMembershipResponseOffset:flatbuffers.Offset) {
  builder.addFieldOffset(28, sharedFolderMembershipResponseOffset, 0);
}

static addUserFindResponse(builder:flatbuffers.Builder, userFindResponseOffset:flatbuffers.Offset) {
  builder.addFieldOffset(29, userFindResponseOffset, 0);
}

static addUserThumbnailResponse(builder:flatbuffers.Builder, userThumbnailResponseOffset:flatbuffers.Offset) {
  builder.addFieldOffset(30, userThumbnailResponseOffset, 0);
}

static addSearchListPageResponse(builder:flatbuffers.Builder, searchListPageResponseOffset:flatbuffers.Offset) {
  builder.addFieldOffset(31, searchListPageResponseOffset, 0);
}

static addFileRootHistoryResponse(builder:flatbuffers.Builder, fileRootHistoryResponseOffset:flatbuffers.Offset) {
  builder.addFieldOffset(32, fileRootHistoryResponseOffset, 0);
}

static addConversationPropertiesResponse(builder:flatbuffers.Builder, conversationPropertiesResponseOffset:flatbuffers.Offset) {
  builder.addFieldOffset(33, conversationPropertiesResponseOffset, 0);
}

static addSearchUpdateResponse(builder:flatbuffers.Builder, searchUpdateResponseOffset:flatbuffers.Offset) {
  builder.addFieldOffset(34, searchUpdateResponseOffset, 0);
}

static addFileFindResponse(builder:flatbuffers.Builder, fileFindResponseOffset:flatbuffers.Offset) {
  builder.addFieldOffset(35, fileFindResponseOffset, 0);
}

static addFileRevisionResponse(builder:flatbuffers.Builder, fileRevisionResponseOffset:flatbuffers.Offset) {
  builder.addFieldOffset(36, fileRevisionResponseOffset, 0);
}

static addConversationUpdateResponse(builder:flatbuffers.Builder, conversationUpdateResponseOffset:flatbuffers.Offset) {
  builder.addFieldOffset(37, conversationUpdateResponseOffset, 0);
}

static addConversationDeleteResponse(builder:flatbuffers.Builder, conversationDeleteResponseOffset:flatbuffers.Offset) {
  builder.addFieldOffset(38, conversationDeleteResponseOffset, 0);
}

static endResponseDatagramBuf(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

}
